<template>
  <div :class="$style.checkoutLayout">
    <div class="pl-5 pr-5 pt-5 pb-5" :class="$style.container">
      <img
        src="resources/images/truelife-logo-org.png"
        alt="Truelife"
        :style="{
          width: '10rem',
        }"
        class="mb-3"
      />
      <h2 class="text-center">Checkout</h2>
      <div :class="$style.errorForm" v-if="!empty(errorMessage)">
        <a-tag color="red">{{ errorMessage }}</a-tag>
      </div>
      <a-row :gutter="20" v-else-if="!empty(accountInfo)">
        <a-form :form="form" :layout="'vertical'" id="checkoutInfo">
          <a-col :span="24">
            <h3>Account Information</h3>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="First Name">
              <a-input v-decorator="['first_name', { rules: [{ required: true, message: 'Please input First Name!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Last Name">
              <a-input v-decorator="['last_name', { rules: [{ required: true, message: 'Please input Last Name!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Billing City">
              <a-input v-decorator="['card_city', { rules: [{ required: true, message: 'Please input billing city!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Billing State">
              <a-input v-decorator="['card_state', { rules: [{ required: true, message: 'Please input billing state!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="isDesktop ? 12 : 24">
            <a-form-item label="Email">
              <a-input
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Please input email!',
                      },
                      {
                        type: 'email',
                        message: 'Please input correct email format!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24" v-if="!empty(planInfo)" class="mb-5">
            <h3>Plan Information</h3>
            <b>Plan:</b>
            {{ planInfo.name }}
          </a-col>

          <a-col :span="24">
            <h3>Billing Information</h3>
          </a-col>

          <a-col :span="24">
            <a-row :gutter="20">
              <a-form :form="formCard" :layout="'vertical'" @submit="handleSubmitCard" id="billingInfo">
                <a-col :span="isDesktop ? 12 : 24">
                  <a-form-item label="First name">
                    <a-input data-recurly="first_name" v-decorator="['first_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputFirstName') }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :span="isDesktop ? 12 : 24">
                  <a-form-item label="Last name">
                    <a-input data-recurly="last_name" v-decorator="['last_name', { rules: [{ required: true, message: $t('placeholder.pleaseInputLastName') }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :span="isDesktop ? 12 : 24">
                  <a-form-item :label="$t('label.cardNumber')">
                    <a-input @keypress.native="isNumber($event)" data-recurly="number" v-decorator="['number', { rules: [{ required: true, message: $t('placeholder.pleaseInputCardNumber') }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :span="isDesktop ? 12 : 24">
                  <a-form-item :label="$t('label.expirationDate')" style="margin: 0;">
                    <a-form-item :style="{ display: 'inline-block', width: '45%' }">
                      <a-input
                        @keypress.native="isNumber($event)"
                        :maxLength="2"
                        data-recurly="month"
                        v-decorator="['month', { rules: [{ required: true, message: $t('placeholder.pleaseInputMonth') }] }]"
                      />
                    </a-form-item>
                    <span :style="{ display: 'inline-block', width: '10%', textAlign: 'center' }">/</span>
                    <a-form-item :style="{ display: 'inline-block', width: '45%' }">
                      <a-input
                        @keypress.native="isNumber($event)"
                        :maxLength="2"
                        data-recurly="year"
                        v-decorator="['year', { rules: [{ required: true, message: $t('placeholder.pleaseInputYear') }] }]"
                      />
                    </a-form-item>
                  </a-form-item>
                </a-col>
                <a-col :span="isDesktop ? 12 : 24">
                  <a-form-item :label="$t('label.CVV')" :style="{ width: '150px' }">
                    <a-input @keypress.native="isNumber($event)" data-recurly="cvv" :maxLength="3" v-decorator="['cvv', { rules: [{ required: true, message: $t('placeholder.pleaseInputCVV') }] }]" />
                  </a-form-item>
                </a-col>
                <input type="hidden" data-recurly="token" name="recurly_code" id="recurlyCode" />
              </a-form>
            </a-row>
          </a-col>
        </a-form>
        <a-col :span="24">
          <a-tag color="red" class="w-100 p-1 mt-1" v-if="!empty(error)">{{ error }}</a-tag>
          <a-button class="mt-3" type="primary" @click="handleSubmit" :loading="isLoading">Submit</a-button>
        </a-col>
      </a-row>
      <div class="d-flex align-items-center bottom-img flex-wrap mt-2">
        <img src="resources/images/satisfactionlogo.png" alt="satisfactionlogo" />
        <img src="resources/images/sslsecurelogo.png" alt="sslsecurelogo" />
        <img src="resources/images/tsys.svg" alt="tsys" />
        <img src="resources/images/visamastercard.png" alt="visamastercard" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { get } from 'lodash';
// import CheckoutService from '@/services/CheckoutService';
import initRecurly from '@/services/Recurly';
import { empty } from '@/utils';
export default {
  data() {
    return {
      accountInfo: {},
      planInfo: {},
      error: '',
      isLoading: false,
      errorMessage: '',
      dataRequired: ['recurly_code', 'signature'],
    };
  },
  computed: {
    ...mapState(['settings', 'user']),
    isDesktop() {
      return !this.settings.isMobileView && !this.settings.isTabletView;
    },
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'individualCheckout' });
    this.formCard = this.$form.createForm(this, { name: 'billingInfo' });
  },
  async mounted() {
    await initRecurly();
    // eslint-disable-next-line camelcase
    const { recurly_code, plan_code, user_id } = this.$route.query;
    console.log(recurly_code, plan_code, this.$route);
    if (empty(recurly_code) || empty(plan_code)) {
      this.errorMessage = 'Recurly code or Plan invalid';
    } else {
      // validate plan_code
      if (empty(plan_code)) {
        this.errorMessage = 'Plan invalid';
      } else {
        recurly.plan(plan_code, (err, data) => {
          if (empty(err)) {
            this.planInfo = data;
            this.accountInfo = {
              recurly_code,
              user_id,
            };
          } else {
            this.errorMessage = err.message;
          }
        });
      }
    }
  },
  methods: {
    empty,
    handleSubmit() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          await this.handleSubmitCard();
          //   try {
          //     this.error = '';
          //     this.isLoading = true;
          //     const resp = await CheckoutService.doIndividualCheckout({
          //       ...values,
          //       ...this.accountInfo,
          //       plan: this.planInfo.code,
          //     });
          //     this.$notification['success']({
          //       message: 'Checkouted successful.',
          //     });
          //     console.log(resp);
          //   } catch (error) {
          //     console.log({ error });
          //     this.error = get(error, 'response.data', error.message);
          //     this.$notification['error']({
          //       message: error.response.status,
          //       description: this.error,
          //     });
          //   } finally {
          //     this.isLoading = false;
          //   }
        }
      });
    },
    checkoutRecurly() {
      return new Promise((resolve, reject) => {
        recurly.token(document.getElementById('billingInfo'), err => {
          if (!empty(err)) {
            reject(err);
          } else {
            resolve();
          }
        });
      });
    },
    isNumber: function (evt) {
      evt = evt || window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 45) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    handleSubmitCard() {
      this.formCard.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.isLoading = true;
            await this.checkoutRecurly();
            // await UserService.doUpdateBillingInfo(document.getElementById('recurlyCode').value);
            this.$notification['success']({
              message: 'Update successful.',
              description: `Credit Card Saved`,
            });
          } catch (error) {
            console.log(error);
            this.$notification['error']({
              message: error.response.status,
              description: get(error, 'response.data.error', error.message),
            });
          } finally {
            this.isLoading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>

<style lang="scss">
.bottom-img img {
  max-width: 25%;
  @media screen and (max-width: 768px) {
    max-width: 50%;
  }
}
</style>
